module.exports = __webpack_public_path__ + "8d7e0fbae3d3bbbf3d676302a975b628.svg";